import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for basic expectation
 */
export interface BasicExpectation {
  location: string;
  work_mode?: string;
  exp_level?: string;
  exp_years?: string;
  emp_type?: string;
  salary_expectation?: string;
  exp_environment?: string;
  role_source?: string;
}

/**
 * Interface for candidate basic expectation payload
 */
export interface CandidateBasicExpectationPayload {
  assessment: string;
  full_name: string;
  email: string;
  portfolio: string;
  resume: string;
  phone_number: string;
  minutes_left: number;
  basic_expectation: BasicExpectation;
  role_source?: string;
}

/**
 * Hook for posting candidate basic expectation using TanStack React Query
 */
export const usePostCandidateBasicExpectation = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: CandidateBasicExpectationPayload) => {
      const response = await apiClient.post('/candidate/basic-expectation/', payload);
      return response.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: 'Success',
        text: 'Candidate basic expectation submitted successfully!',
        type: 'info',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err?.response?.data?.message || 'Failed to submit candidate basic expectation';
      openToast({
        show: true,
        heading: 'Submission Failed',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};
